// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-cell[data-v-376e7bdd]:after{border-bottom:0}.doctorCommunicationInputs[data-v-376e7bdd]{background-color:#fff;color:#1989fa;padding:5px 10px;border-radius:8px;box-shadow:0 0 5px 0 #c8c9cc;margin:5px;max-width:65vw}.customerCommunicationInputs[data-v-376e7bdd]{background-color:#1989fa;color:#fff;padding:5px 10px;border-radius:8px;margin:0 5px;max-width:65vw}[data-v-376e7bdd]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
